import { render, staticRenderFns } from "./PvDrawerToggleButton.vue?vue&type=template&id=71ce2443&scoped=true&"
import script from "./PvDrawerToggleButton.vue?vue&type=script&lang=js&"
export * from "./PvDrawerToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./PvDrawerToggleButton.vue?vue&type=style&index=0&id=71ce2443&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce2443",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
